// extracted by mini-css-extract-plugin
export var editor = "_1c-0";
export var flowSidebar = "_50-2";